import Icon from '@ant-design/icons'

const SVG = () => (
    <svg
        t='1717569483014'
        className='icon'
        viewBox='0 0 1024 1024'
        version='1.1'
        xmlns='http://www.w3.org/2000/svg'
        p-id='2421'
        width='200'
        height='200'
    >
        <path
            d='M774.3104 349.44 249.6 349.44l262.3552 327.95008L774.3104 349.44zM511.9552 677.39008'
            fill='currentColor'
            p-id='2422'
        ></path>
    </svg>
)

export const SelectIcon = props => <Icon component={SVG} {...props} />
